import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import React, { useRef } from "react";

export default (
    {
        onConfirm,
        title = 'Вы уверены',
        buttonText = 'Да',
        placement = 'left',
        warning,
        children
    }) => {
    const overlayTriggerRef = useRef(null);

    const popover = (
        <Popover
            id="popover-confirm"
            title={title}
            style={{ textAlign: 'center' }}
        >
            {warning ? <p>{warning}</p> : <Button onClick={() => {
                onConfirm();
                overlayTriggerRef.current.handleToggle()
            }}>{buttonText}</Button>}
        </Popover>
    );

    return (
        <OverlayTrigger ref={overlayTriggerRef} trigger="click" rootClose placement={placement} overlay={popover} >
            {children}
        </OverlayTrigger>
    );
}

